import React from 'react';
import { Route, Switch, useRouteMatch, Redirect, useParams } from 'react-router';
import { useGetInvestmentFundQuery } from 'api/main';

import FundManagementTable from './FundManagementTable';
import FundAttributes from './fund-attributes/FundAttributes';
import PrivateFunds from './PrivateFunds';
import Tunnels from './Tunnels';
import VLManagement from './VLManagement';
import { Loader } from 'components';

const FundManagement = () => {
    const { path } = useRouteMatch();
    const { fundId } = useParams();

    const { data: fund, isLoading } = useGetInvestmentFundQuery(fundId, { skip: !+fundId });

    return (
        <Switch>
            <Route path={`${path}/:fundId/attributes`} component={FundAttributes} exact />
            <Route path={`${path}/create`} component={FundAttributes} exact />
            <Route
                path={`${path}/:fundId/reserved`}
                render={() => {
                    if (isLoading) return <Loader loading={isLoading} width="100%" />;
                    return fund?.private ? (
                        <PrivateFunds fundName={fund?.name} />
                    ) : (
                        <Redirect to="/fund-management" />
                    );
                }}
                exact
            />
            <Route
                path={`${path}/:fundId/vl-management`}
                render={() => {
                    if (isLoading) return <Loader loading={isLoading} width="100%" />;
                    return fund?.evergreen ? (
                        <VLManagement fund={fund} />
                    ) : (
                        <Redirect to="/fund-management" />
                    );
                }}
                exact
            />
            <Route
                path={`${path}/:fundId/tunnels`}
                render={() => <Tunnels fundName={fund?.name} />}
                exact
            />
            <Route path="/fund-management" render={() => <FundManagementTable />} exact />
            <Redirect to="/fund-management" />
        </Switch>
    );
};

export default FundManagement;
